import CommonLoader from "../common/CommonLoader";

const ConfirmationModal = ({
  isOpen,
  title = "Confirm Action",
  description = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
      <div className="bg-white rounded-[20px] max-w-[480px] w-full mx-4 relative">
        {isLoading && <CommonLoader fullScreen />}

        <div className="p-8">
          {/* Title */}
          <h2 className="text-[26px] font-semibold text-black mb-2">
            {title}
          </h2>

          {/* Description */}
          <p className="text-[16px] text-[#666666] mb-8">
            {description}
          </p>

          {/* Buttons */}
          <div className="flex gap-4">
            <button
              onClick={onCancel}
              disabled={isLoading}
              className="flex-1 h-[52px] rounded-full border border-[#06323A] text-[#06323A] font-medium hover:bg-gray-50 disabled:opacity-50"
            >
              {cancelText}
            </button>

            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="flex-1 h-[52px] rounded-full bg-[#0A3A44] text-white font-medium hover:opacity-90 disabled:opacity-50"
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
